import { handleActions } from 'redux-actions';
import configActions from './actions';
import { LOCATION_CHANGE } from 'react-router-redux';

export const initialState = {
  error: null
};

const reducer = handleActions({
  [configActions.config.public.api.get.request]: (state, action) => ({
    ...state,
    isFetching: true
  }),
  [configActions.config.public.api.get.success]: (state, action) => ({
    ...state,
    ...action.payload.config,
    isFetching: false
  }),
  [configActions.config.public.api.get.failed]: (state, action) => ({
    ...state,
    isFetching: false,
    error: action.payload.error
  }),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    error: null
  })
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/configuration/reducers.js